import { Event } from '.';

export default class MouseEvent extends Event {
  public static CLICK: string = 'click';

  public static MOUSE_DOWN: string = 'mouseDown';

  public static MOUSE_UP: string = 'mouseUp';

  public static MOUSE_MOVE: string = 'mouseMove';

  public static DOUBLE_CLICK: string = 'doubleClick';
}
